import * as React from 'react'
import profileImage from "../imgs/profile.png"
import "../css/about.scss"
import {Card} from "./Card";
import MediaQuery from "react-responsive";
import {useEffect, useState} from "react";
import * as $ from 'jquery'
import {TwitterTimelineEmbed} from "react-twitter-embed"
import {Loader} from "./Loader";

interface ReceiveData {
    status: number
    data: any
}

const initialData: ReceiveData = { status: 0, data: null };

export const About : React.FC<{}> = () => {
    let [show, setShow] = useState<boolean>(false);
    const date = new Date();
    const age = date.getFullYear() - 1983 - (date.getMonth() < 11 ? 1 : date.getDate() < 27 ? 1 : 0);
    let [status, setStatus] = useState<ReceiveData>(initialData);

    function receiveData() {
        $.ajax("https://script.google.com/macros/s/AKfycbzX2aPXNPnl9FbIVYXA62jt-JAbII9WSyyolTX4Y3QZr59ywuI/exec?type=status", {
            type: "get"
        }).done((data) => {
            setStatus(data);
        });
    }
    useEffect(() => {
        receiveData();
    }, [initialData]);

    function showMore() {
        if(show) {
            return (
                <React.Fragment>
                    <tr>
                        <th>Like</th>
                        <td>
                            <ul>
                                <li>星のカービィ</li>
                                <li>犬・猫</li>
                                <li>エビフライ</li>
                                <li>ホイップクリーム</li>
                                <li>お酒(ビール・ウィスキー)</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Hobby</th>
                        <td>
                            <ul>
                                <li>読書(19世紀文学中心)</li>
                                <li>アプリ開発</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>My Boom</th>
                        <td>
                            <ul>
                                <li>SwiftとGo</li>
                                <li>Sound Horizon</li>
                                <li>平沢進</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Others</th>
                        <td>
                            小学生の頃占い師から「前世は海老です。しかも他の海老達にいじめられて死にました」って言われて以来意識的に海老を食べるようにしています。
                        </td>
                    </tr>
                </React.Fragment>
            )
        }
        return (
            <tr>
                <td colSpan={2} className={"about-more"} onClick={() => { setShow(true); }}><div className={"arrow"}/>More</td>
            </tr>
        )
    }

    function showStatus() {
        if(status.status === 0) {
            return (
                <Loader/>
            );
        }
        if(status.status === 200) {
            return status.data.current;
        }
        return (
            <div className="notification is-danger">
                データ取得に失敗しました。 <a href={"https://twitter.com/br_branch"} target={"_blank"}>Twitter</a>で教えてもらえると嬉しいです。
            </div>
        );
    }

    return (
        <div className={`container about-root`}>
            <h1 className={"title"}>About</h1>
            <div className={"panel about-panel"}>
                <div className={"panel-block"}>
                    2020年に独立し、BRBranchという屋号でフリーランスで活動しています。
                </div>
                <div className={"panel-block"}>
                    <span className={"about-work"}>現在の状況</span><span>{showStatus()}</span>
                </div>
            </div>
            <h1 className={"title"}>Profile</h1>
            <div className={"panel about-panel"}>
                <MediaQuery query="(max-width: 767px)">
                    <img src={profileImage} className={"about-image"} alt={"プロフィール画像"}/>
                </MediaQuery>
                <MediaQuery query="(min-width: 768px)">
                    <Card src={profileImage} className={"about-image"} alt={"プロフィール画像"} width={100} height={100}/>
                </MediaQuery>
                <table className={"table is-fullwidth"}>
                    <tbody>
                    <tr>
                        <th>RealName</th>
                        <td>小田 一貴(Oda Kazuki)</td>
                    </tr>
                    <tr>
                        <th>HandleName</th>
                        <td>branch、ぶらんち</td>
                    </tr>
                    <tr>
                        <th>Date of birth</th>
                        <td>1983年11月({age}歳)</td>
                    </tr>
                    <tr>
                        <th>Skill</th>
                        <td>
                            <ul>
                                <li>Java(6年)</li>
                                <li>C/C++(7年)</li>
                                <li>Go(3年)</li>
                                <li>Swift(4年)</li>
                                <li>Objective-c(2年)</li>
                                <li>C#(2年弱)</li>
                                <li>JavaScript(10年以上)</li>
                                <li><a href={"https://www.resume.id/branch"} className={"block"} target={"_blank"}>その他</a></li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Career</th>
                        <td>
                            <div>
                                フルスタックエンジニアとしてシステム開発(バックエンド中心)やネイティブアプリ開発を中心に行ってきました。<br/><br/>
                                独立する前はグループマネージャーを務めてましたが、学生時代も含めるとプログラミング歴は20年以上あり、開発力には自信あります。<br/>
                                フロントサイドは苦手な方ですが、このサイト程度の規模なら作成できます。<br/>
                            </div>
                            <a href={"https://www.resume.id/branch"} className={"block"} target={"_blank"}>経歴詳細</a>
                        </td>
                    </tr>
                    {showMore()}
                    </tbody>
                </table>
            </div>
        </div>
    );
}